/*
 * fonctions spécifiques au formulaire client
 */
if( $('#frm_client').get().length ) {


	/*
	 * switch conversion client
	 */
	$('#frm_client_client').change(function() {
		var $this = $(this);
		if( $this.prop('checked') ) {
			$('#zone_client_alerte').removeClass('d-none');
			$('.only_client').removeClass('d-none');
			$('.only_prospect').addClass('d-none');
			//$('#frm_client_societaire').prop('checked', true);

			$('#frm_client_civilite').prop('required', true);
			$('[for="frm_client_civilite"]').append('<span class="text-danger">*</span>');
			$('#frm_client_prenom').prop('required', true);
			$('[for="frm_client_prenom"]').append('<span class="text-danger">*</span>');
			$('#frm_client_email').prop('required', true);
			$('[for="frm_client_email"]').append('<span class="text-danger">*</span>');
			$('#frm_client_adresse').prop('required', true);
			$('[for="frm_client_adresse"]').append('<span class="text-danger">*</span>');
			$('#frm_client_cp').prop('required', true);
			$('[for="frm_client_cp"]').append('<span class="text-danger">*</span>');
			$('#frm_client_ville').prop('required', true);
			$('[for="frm_client_ville"]').append('<span class="text-danger">*</span>');
		}
		else {
			$('#zone_client_alerte').addClass('d-none');
			$('.only_client').addClass('d-none');
			$('.only_prospect').removeClass('d-none');
			$('#frm_client_societaire').prop('checked', false);

			$('#frm_client_civilite').prop('required', false);
			$('[for="frm_client_civilite"] span').remove();
			$('#frm_client_prenom').prop('required', false);
			$('[for="frm_client_prenom"] span').remove();
			$('#frm_client_email').prop('required', false);
			$('[for="frm_client_email"] span').remove();
			$('#frm_client_adresse').prop('required', false);
			$('[for="frm_client_adresse"] span').remove();
			$('#frm_client_cp').prop('required', false);
			$('[for="frm_client_cp"] span').remove();
			$('#frm_client_ville').prop('required', false);
			$('[for="frm_client_ville"] span').remove();
		}
	});

	$('#frm_client_societaire').change(function() {
		var $this = $(this);
		if( $this.prop('checked') ) {
			$('.only_societaire').removeClass('d-none');
		}
		else {
			$('.only_societaire').addClass('d-none');
		}
	});


	/*
	 * switch personne_morale
	 */
	/*$('#frm_client_personne_morale').change(function() {
		var $this = $(this);
		if( $this.prop('checked') ) {
			$('#frm_client_prenom').attr('required', false);
			$('#frm_client_prenom').attr('placeholder', $('#frm_client_prenom').attr('placeholder').replace(/\*$/g, ''));
			$('label[for="frm_client_prenom"] .text-danger').addClass('d-none');
		}
		else {
			$('#frm_client_prenom').attr('required', true);
			$('#frm_client_prenom').attr('placeholder', $('#frm_client_prenom').attr('placeholder') + '*');
			$('label[for="frm_client_prenom"] .text-danger').removeClass('d-none');
		}
	});*/


	/*
	 * gestion des doublons
	 */
	$('[data-doublon]').click(function(e) {
		e.preventDefault();
		var $this = $(this);
		$.ajax({
			type: "POST",
			data: $('#frm_client').serialize() + '&action=doublon&doublon=' + $this.data('doublon')
		}).done(function(data) {
			$('#frm_client').removeClass('w-100').addClass('w-50 pr-3 border-right');
			$('#doublon-container').addClass('w-50 pl-3 border-left').html(data);
			$('#frm_client_footer').append('<input type="hidden" name="_merge" value="' + $this.data('doublon') + '">' +
				'<button type="submit" name="action" value="modify" class="btn btn-warning btn-lg float-right">' + 
					'<i class="material-icons">edit</i> ' + 
					'<span>' + __str('Mettre à jour') + ' ' + $this.data('nom') + '</span>' + 
				'</button>');
		});
	});


	/*
	 * calcul automatique de l'apport
	 */
	$(document).on('input', '._calcapport', function() {
		var $this = $(this);
		var val = getPrixFormat($this.val());
		var parent = $this.parents('.tab-pane').get(0);
		var prix_ttc = getPrixFormat($('.prix_ttc', parent).val());
		if( val != '' && prix_ttc != '' ) {
			if( $this.hasClass('apport_personnel') ) {
				$('.pourcentage_apport_personnel', parent).val( prixFormat( val / prix_ttc * 100 ) );
			}
			else if( $this.hasClass('pourcentage_apport_personnel') ) {
				$('.apport_personnel', parent).val( prixFormat( prix_ttc * (val / 100) ) );
			}
		}
		$(this).val( prixFormat($(this).val()) );
	});

	/*
	 * calcul automatique de l'effort
	 */
	$(document).on('input', '._calceffort', function() {
		var $this = $(this);
		var parent = $this.parents('.tab-pane').get(0);
		var prix_part_locative = parseFloat(getPrixFormat($('.prix_part_locative', parent).val()));
		if( isNaN(prix_part_locative) )
			prix_part_locative = 0;
		var prix_part_acquisitive = parseFloat(getPrixFormat($('.prix_part_acquisitive', parent).val()));
		if( isNaN(prix_part_acquisitive) )
			prix_part_acquisitive = 0;
		var prix_vefa_mensualite_max_simulation = parseFloat(getPrixFormat($('.prix_vefa_mensualite_max_simulation', parent).val()));
		if( isNaN(prix_vefa_mensualite_max_simulation) )
			prix_vefa_mensualite_max_simulation = 0;
		var prets_en_cours = parseFloat(getPrixFormat($('.prets_en_cours', parent).val()));
		if( isNaN(prets_en_cours) )
			prets_en_cours = 0;
		var revenus_mensuels = parseFloat(getPrixFormat($('.revenus_mensuels', parent).val()));
		if( !isNaN(revenus_mensuels) && !isNaN(prix_part_acquisitive) && !isNaN(prix_part_locative) ) {
			$('.taux_effort', parent).val( prixFormat( (prix_part_locative + prix_part_acquisitive + prix_vefa_mensualite_max_simulation) / revenus_mensuels * 100 ) );
		}
		$(this).val( prixFormat($(this).val()) );
	});


	/*
	 * calcul automatique du reste à vivre
	 */
	$(document).on('input', '._calcresteavivre', function() {
		var $this = $(this);
		var parent = $this.parents('.tab-pane').get(0);
		var prix_part_locative = parseFloat(getPrixFormat($('.prix_part_locative', parent).val()));
		if( isNaN(prix_part_locative) )
			prix_part_locative = 0;
		var prix_part_acquisitive = parseFloat(getPrixFormat($('.prix_part_acquisitive', parent).val()));
		if( isNaN(prix_part_acquisitive) )
			prix_part_acquisitive = 0;
		var prix_vefa_mensualite_max_simulation = parseFloat(getPrixFormat($('.prix_vefa_mensualite_max_simulation', parent).val()));
		if( isNaN(prix_vefa_mensualite_max_simulation) )
			prix_vefa_mensualite_max_simulation = 0;
		var prets_en_cours = parseFloat(getPrixFormat($('.prets_en_cours', parent).val()));
		if( isNaN(prets_en_cours) )
			prets_en_cours = 0;
		var revenus_mensuels = parseFloat(getPrixFormat($('.revenus_mensuels', parent).val()));
		if( !isNaN(revenus_mensuels) && !isNaN(prix_part_acquisitive) && !isNaN(prix_part_locative) ) {
			$('.reste_a_vivre', parent).val( prixFormat( revenus_mensuels - (prix_part_locative + prix_part_acquisitive + prix_vefa_mensualite_max_simulation + prets_en_cours) ) );
		}
		$(this).val( prixFormat($(this).val()) );
	});

	$('.revenus_mensuels').each(function(i, el) {
		$(el).trigger('input');
	});


	// switch personne morale
	$('#frm_client_switch_personne_morale').change(function() {
		if( $(this).prop('checked') )
			$('#personne_morale_holder').removeClass('d-none');
		else
			$('#personne_morale_holder').addClass('d-none');
	});


	$('.zone_prospect_relance .btn-success[data-id]').on('click', function() {
		$('.zone_prospect_relance').html('<input type="hidden" name="relance_traitee" value="' + $(this).data('id') + '"><span class="text-success">Relance traitée</span>');
	});
	$('.zone_prospect_relance .btn-danger[data-id]').on('click', function() {
		$('.zone_prospect_relance').html('<input type="hidden" name="relance_annulee" value="' + $(this).data('id') + '"><span class="text-danger">Relance annulée</span>');
	});

	$('.zone_prospect_relance #frm_client_relance').on('change', function() {
		if( $(this).prop('checked') )
			$('.zone_prospect_relance .zone_prospect_relance_rappel').removeClass('d-none');
		else
			$('.zone_prospect_relance .zone_prospect_relance_rappel').addClass('d-none');
	});

	// revente programme -> lot
	$('#frm_client_revente_programme').change(function() {
		$('.revente_lot_field').addClass('d-none');
		$('.revente_lot_field select').attr('disabled', true);
		if ( $('#frm_client_revente_programme').val() != '' ) {
			$('#revente_lot_' + $('#frm_client_revente_programme').val()).removeClass('d-none');
			$('#revente_lot_' + $('#frm_client_revente_programme').val() + ' select').attr('disabled', false);
		}
	});

	// calcul jeune ménage
	$('#frm_client_date_naissance, #frm_client_date_naissance2, .date_signature_contrat_reservation').on('input', function() {
		var date_naissance = false;
		var value = $('#frm_client_date_naissance').val();
		if ( value.length == 10 ) {
			if ( value.match(/^\d{4}-\d{2}-\d{2}$/) ) {
				date_naissance = new Date(value);
			} else if ( value.match(/^\d{2}\/\d{2}\/\d{4}$/) ) {
				date_naissance = new Date(value.substring(6, 10) + '-' + value.substring(3, 5) + '-' + value.substring(0, 2));
			}
		}
		var date_naissance2 = false;
		var value = $('#frm_client_date_naissance2').val();
		if ( value.length == 10 ) {
			if ( value.match(/^\d{4}-\d{2}-\d{2}$/) ) {
				date_naissance2 = new Date(value);
			} else if ( value.match(/^\d{2}\/\d{2}\/\d{4}$/) ) {
				date_naissance2 = new Date(value.substring(6, 10) + '-' + value.substring(3, 5) + '-' + value.substring(0, 2));
			}
		}
		if ( date_naissance && date_naissance2 ) {
			document.querySelectorAll('#frm_client input.date_signature_contrat_reservation').forEach(el => {
				var date = false;
				var value = el.value;
				if ( value.length == 10 ) {
					if ( value.match(/^\d{4}-\d{2}-\d{2}$/) ) {
						date = new Date(value);
					} else if ( value.match(/^\d{2}\/\d{2}\/\d{4}$/) ) {
						date = new Date(value.substring(6, 10) + '-' + value.substring(3, 5) + '-' + value.substring(0, 2));
					}
				}
				if ( date ) {
					var age = 0;
					if ( date_naissance ) {
						date_naissance.setHours(24, 0, 0, 0);
						var ageDifMs = date - date_naissance;
						var ageDate = new Date(ageDifMs); // miliseconds from epoch
						age += Math.abs(ageDate.getUTCFullYear() - 1970);
					}
					if ( date_naissance2 ) {
						date_naissance2.setHours(24, 0, 0, 0);
						var ageDifMs = date - date_naissance2;
						var ageDate = new Date(ageDifMs); // miliseconds from epoch
						age += Math.abs(ageDate.getUTCFullYear() - 1970);
					}
					el.closest('.tab-pane').querySelector('.jeune_menage').checked = age <= 55;
				}
			});
		}
	});


	// champs à afficher selon le type de contrat
	$('#anchor-client-contrat select.type_contrat').on('change', function() {
		var $this = $(this);
		var $container = $this.parents('.tab-pane');
		$container.find('.zonefield').removeClass('d-none');
		if ( $this.val() == 'VEFA' || $this.val() == 'VEFA BRS' || $this.val() == 'ACHEVÉ' ) {
			$container.find('.zonefield.date_envoi_banque, .zonefield.date_reponse_banque, .zonefield.date_accord_banque, .zonefield.date_signature_contrat, .zonefield.numero_contrat_psla, .zonefield.date_levee_option, .zonefield.date_demande_resiliation, .zonefield.date_sortie').addClass('d-none');
		} else if ( $this.val() == 'PSLA' ) {
			$container.find('.zonefield.date_signature_acte').addClass('d-none');
		}
	}).change();


	// lier nouveau lot
	$('#lier_new_lot_programme').change(function() {
		$('.lier_new_lot_lot').addClass('d-none');
		$('.lier_new_lot_lot').attr('disabled', true);
		if ( $('#lier_new_lot_programme').val() != '' ) {
			$('#lier_new_lot_lot_' + $('#lier_new_lot_programme').val()).removeClass('d-none');
			$('#lier_new_lot_lot_' + $('#lier_new_lot_programme').val()).attr('disabled', false);
			$('#lier_new_lot_lot_' + $('#lier_new_lot_programme').val()).change();

		}
	});
	$('.lier_new_lot_lot').change(function() {
		if ( $(this).val() != '' ) {
			$('#lier_new_lot ._inner .btn_validate').data('src', $('#lier_new_lot ._inner .btn_validate').data('baseurl') + $(this).val() );
			$('#lier_new_lot ._inner .btn_validate').removeClass('d-none');
		} else {
			$('#lier_new_lot ._inner .btn_validate').addClass('d-none');
		}
	});
	$('#lier_new_lot .btn_add').on('click', function() {
		$(this).addClass('d-none');
		$('#lier_new_lot ._inner').addClass('d-flex');
	});
	$('#lier_new_lot .btn_close').on('click', function() {
		$('#lier_new_lot .btn_add').removeClass('d-none');
		$('#lier_new_lot ._inner').removeClass('d-flex');
	});

}